module.exports = __webpack_public_path__ + "img/learningTheory1.3e1bdc67.png";